import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import AdminSessionGuard, { useAdminSession } from '../auth/AdminSessionGuard';
import { Loader } from '../components/ui/Loader';
import AdminLayout from '../layouts/AdminLayout';
import AccountCreatePage from '../pages/admin/accounts/AccountCreatePage';
import AccountEditPage from '../pages/admin/accounts/AccountEditPage';
import AccountPaymentPage from '../pages/admin/accounts/AccountPaymentPage';
import BookDetailsPage from '../pages/admin/accounts/BookDetailsPage';
import AdminDashboard from '../pages/admin/dashboard/AdminDashboard';
import DrawTimePage from '../pages/admin/draw-time/DrawTimePage';
import ChangePasswordPage from '../pages/admin/auth/ChangePasswordPage';
import ReportsPage from '../pages/admin/reports/ReportsPage';
import DrawResultPage from '../pages/admin/results/DrawResultPage';
import BalanceUpdatePage from '../pages/admin/balance/BalanceUpdatePage';
import DataFilterPage from '../pages/admin/data-filter/DataFilterPage';
import LoginPage from '../pages/auth/LoginPage';
import UserEntryTerminal from './UserEntryTerminal';

const LegacyApp = lazy(() => import('./App'));

function LegacyCompatibility() {
  return (
    <Suspense fallback={<Loader fullScreen label="Loading existing panel…" />}>
      <LegacyApp />
    </Suspense>
  );
}

function AdminOnlyDrawTime() {
  const { session } = useAdminSession();
  return session.user.role === 'ADMIN' ? <DrawTimePage /> : <Navigate to="/" replace />;
}
function AdminOnlyDrawResult() {
  const { session } = useAdminSession();
  return session.user.role === 'ADMIN' ? <DrawResultPage /> : <Navigate to="/" replace />;
}
function AdminOnlyBalanceUpdate() {
  const { session } = useAdminSession();
  return session.user.role === 'ADMIN' ? <BalanceUpdatePage /> : <Navigate to="/" replace />;
}
function AdminOnlyDataFilter() {
  const { session } = useAdminSession();
  return session.user.role === 'ADMIN' ? <DataFilterPage /> : <Navigate to="/" replace />;
}

export const router = createBrowserRouter([
  {
    path: '/login/*',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <AdminSessionGuard fallback={<UserEntryTerminal />} />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminDashboard /> },
          { path: 'accounts/new/', element: <AccountCreatePage /> },
          { path: 'accounts/:id/edit/', element: <AccountEditPage /> },
          { path: 'accounts/:id/payment/', element: <AccountPaymentPage /> },
          { path: 'payment-details/', element: <BookDetailsPage /> },
          { path: 'draw-time/', element: <AdminOnlyDrawTime /> },
          { path: 'draw-result/', element: <AdminOnlyDrawResult /> },
          { path: 'balance-update/', element: <AdminOnlyBalanceUpdate /> },
          { path: 'data-filter/', element: <AdminOnlyDataFilter /> },
          { path: 'change-password/', element: <ChangePasswordPage /> },
          { path: 'hierarchy-reports/', element: <ReportsPage /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <LegacyCompatibility />,
  },
]);

export default router;
